import Skeleton from "react-loading-skeleton";

function PinCodeSection({
  localLoading,
  pincode,
  setPincode,
  isPincodeLocked,
  handleCheck,
  pinloading,
  handleReset,
  pincodeDetails,
  LocationTick,
}) {
  const handleChange = (e) => {
    if (isPincodeLocked) return;

    const onlyNums = e.target.value.replace(/\D/g, "");

    if (onlyNums.length <= 6) {
      setPincode(onlyNums);

      if (onlyNums.length === 6 && !pinloading) {
        handleCheck();
      }
    }
  };

  return (
    <div className="pincode-check">
      <p className="check-heading">
        {localLoading ? <Skeleton width={180} /> : "Check Availability"}
      </p>

      {localLoading ? (
        <>
          <Skeleton height={40} width={250} />
          <Skeleton width={200} />
        </>
      ) : (
        <>
          <div className="input-wrapper">
            <input
              className="checkup_track_txt"
              type="text"
              placeholder="Enter Delivery Pincode"
              value={pincode}
              maxLength={6}
              disabled={isPincodeLocked}
              onChange={handleChange}
              onKeyUp={() => {
                if (pincode?.length === 6 && !isPincodeLocked) {
                  handleCheck();
                }
              }}
            />

            <div className="btn-group">
              {!isPincodeLocked && (
                <button
                  onClick={handleCheck}
                  className="check-btn-2"
                  disabled={pinloading || pincode.length !== 6}
                >
                  {pinloading ? "Checking..." : "Check"}
                </button>
              )}

              {isPincodeLocked && (
                <button onClick={handleReset} className="rest-btn">
                  Reset
                </button>
              )}
            </div>
          </div>

          <div className="root_avl">
            <p className="avl_trck" style={{ marginBottom: "5px" }}>
              Available PAN India. We deliver wherever you call home.
            </p>
            {/* <span className="avl_trck">
              Shipping Charges calculated at checkout.
            </span> */}
            
          </div>

          {pinloading && <p className="check_test">Checking...</p>}

          {!pinloading &&
            pincode?.length === 6 &&
            pincodeDetails?.pincode &&
            pincodeDetails?.is_active && (
              <p style={{ color: "green", marginTop: "15px" }}>
                <span style={{ position: "relative", bottom: "5px" }}>
                  <LocationTick size="24" color="green" variant="Bold" />
                </span>
                Delivery available at {pincodeDetails?.city},{" "}
                {pincodeDetails?.state} ({pincodeDetails?.delivery_tat})
              </p>
            )}
        </>
      )}
    </div>
  );
}

export default PinCodeSection;